import { LOGIN_METHOD_KEY, LoginMethod } from 'root-constants'

export const setLoginMethodToLocalStorage = (loginMethod: LoginMethod) => {
  localStorage.setItem(LOGIN_METHOD_KEY, loginMethod)
}
